
  export default {
    name: "TimeAnalogClock",
    props: {
      start: {
        type: String,
        required: true,
      },
      end: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
      };
    },
    methods: {
      getMinutes(hour) {
        let hh = this.$moment(hour, 'HH:mm').get('hour');
        let mm = this.$moment(hour, 'HH:mm').get('minutes');

        if(hh > 12) {
          return ((hh - 12)*60) + mm
        }

        return (hh*60) + mm

      },
      localFormat(hour) {
        let locale = this.$i18n.locale
        if (locale != 'en') {
          return this.$moment(hour, 'HH:mm').format("HH:mm");
        }
        return this.$moment(hour, 'HH:mm').format("hh:mm A");
      },
      getHourInDecimal(hour){
        var hh = this.$moment(hour, 'HH:mm').get('hour');
        var mm = this.$moment(hour, 'HH:mm').get('minutes');

        let minToDecimal = ((mm * 100 ) / 60) / 100;

        return hh + minToDecimal
      }
    },
    mounted() {
      // SELECTING CANVAS AND CONTEXT
      const canvas = this.$refs['clock-canvas'];
      const ctx = this.$refs['clock-canvas'].getContext('2d');

      // GET CANVAS DIMENSION
      const width = 400
      const height = 400

      // GET START AND END HOUR
      const startHour = this.getHourInDecimal(this.start)
      const endHour = this.getHourInDecimal(this.end)

      // GET TE ARC COLOR
      var style = getComputedStyle(document.body)

      // Set the radius of the clock to be half the width or height, whichever is smaller
      const radius = Math.min(width, height) / 2;

      // Calculate the angles for the check-in and check-out times in radians
      const start = startHour / 12 * Math.PI;
      const end = endHour / 12 * Math.PI;

      // Set the starting and ending angles for the green arc
      const startAngle = start - Math.PI / 2;
      const endAngle = end - Math.PI / 2;

      // Set the line width and color for the green arc
      ctx.lineWidth = 0;
      ctx.strokeStyle = style.getPropertyValue('--secondary');
      ctx.fillStyle = style.getPropertyValue('--secondary')

      // Go to center of canvas
      ctx.moveTo(canvas.width / 2, canvas.height / 2);

      // Draw the green arc
      ctx.beginPath();
      ctx.arc(canvas.width / 2, canvas.height / 2, radius - 5, startAngle, endAngle);
      ctx.lineTo(canvas.width / 2, canvas.height / 2);
      ctx.fill();
      ctx.stroke();

    },
    computed: {
    }
  };
